import { supabase } from '@/integrations/supabase/client'

interface ApiOptions extends RequestInit {
  auth?: boolean
}

export class ApiError extends Error {
  status: number
  data?: any

  constructor(message: string, status: number, data?: any) {
    super(message)
    this.status = status
    this.data = data
  }
}

export const api = async <T>(url: string, options: ApiOptions = {}): Promise<T> => {
  const baseUrl = import.meta.env.VITE_SUPABASE_URL + '/functions/v1'
  
  // Build headers
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...(options.headers || {})
  }
  
  // Add auth token if needed
  if (options.auth !== false) {
    const { data: { session } } = await supabase.auth.getSession()
    if (session?.access_token) {
      headers.Authorization = `Bearer ${session.access_token}`
    } else {
      // Use anon key as fallback
      const anonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
      if (anonKey) {
        headers.Authorization = `Bearer ${anonKey}`
      }
    }
  }

  const res = await fetch(`${baseUrl}${url}`, {
    ...options,
    headers
  })

  const responseData = await res.json()

  if (!res.ok) {
    throw new ApiError(
      responseData.error || 'An error occurred',
      res.status,
      responseData
    )
  }

  return responseData
}